import './index.scss';
import AnimatedLetters from '../AnimatedLetters'
import {useState, useEffect} from 'react'
import {Loader} from 'react-loaders'

const WorkExp = () =>{
    const [letterClass, setLetterClass] = useState('text-animate');

    useEffect(() => {
        setTimeout(() => {
          return setLetterClass('text-animate-hover')
        }, 5500)
      }, [])

    return (
        <div>
            <div className = 'container work-ex' > 
                <div className = 'text-zone' style = {{'width': '80%'}}> 
                    
                    <h1> 
                        <AnimatedLetters 
                            letterClass={letterClass}
                            strArray={['W','o','r','k',' ','E','x','p','e','r','i','e','n','c','e']}
                            idx = {15} 
                        />
                    </h1>

                    <div className = 'work-exp-map'>

                        <div className = 'work-ex-done'>

                            <h3>Group 52 at Lincoln Laboratory, <br/>Massachusetts Institute of Technology (MIT)</h3> 
                            <h5> May 2022 to August 2022 </h5>

                            <b>*NF*</b>
                        </div>
                        
                        <div className = 'work-ex-done'>

                            <h3>Graduate Researcher at Society + AI &amp; Language, <br/>Virginia Tech  </h3> 
                            <h5> August 2021 to Present </h5>

                            <ul>
                            	<li>
                                    Used BERT-based language model to analyse differences in linguistic patterns between politically distinct news networks. Used Integrated gradients to identify themes and phrases predictive of moral panic. <b>(Under Review at ICWSM)</b>.                                
                                </li>
                                <li>
                                    Conducting research work focussed on investigating communicative patterns of groupthink in political discussions around topics that are wrought with mis/disinformation and examining how racial bias in news media has evolved overtime using a combination of NLP techniques such as transformers and deep audio analytics.                           
                                </li>
                                <li>
                                    Built a multimodal model (Vision + Text) to analyze the spread of genocidal language in political memes.
                                </li>
                                <li>
                                    Adapted methodological intuitions from prior work to develop a new technique to quantify how semantic polarization – the semantic distance between how two entities contextually use an identical word – evolves over time in online social movements.
                                </li>
                            </ul>
                        </div>

                        <div className = 'work-ex-done'>

                            <h3>Data Science Intern at Peraton</h3> 
                            <h5> January 2022 to May 2022 </h5>

                            <ul>
                            	<li>
                                    Predicting hospital readmission using ensembling algorithms and feature engineering.                 
                                </li>
                                <li>
                                    Mapping the spread of COVID-19 in at-risk communities using time-series datasets.                           
                                </li>
                            </ul>
                        </div>

                        <div className = 'work-ex-done'>

                            <h3>Lead Machine Learning Application Developer at Innovation Labs, Concentrix Corporation</h3> 
                            <h5> June 2018 to July 2021 </h5>

                            <ul>
                                <li>
                                    Improved internal speech recognition for user authentication system by using Mel frequency cepstral coefficients &amp; probability-based GMM.
                                </li>
                                <li>
                                    Developed a friend recommendation system using collaborative filtering and link prediction.
                                </li>
                                <li>
                                    Home-Agent monitoring system via movement tracking, background noise detection, shoulder surfing, and face verification.          
                                </li>
                                <li>
                                    Developed a face hashing pipeline using VGG face and Face-Net model, to match face indexes. Accuracy 99%.
                                </li>
                            </ul>
                        </div>

                    </div>

                </div>

            </div>
            <Loader type = 'pacman'></Loader>

        </div>
    )
};


export default WorkExp;